import { render, staticRenderFns } from "./deliveryFeeConfigManageList.vue?vue&type=template&id=02266afd&scoped=true"
import script from "./deliveryFeeConfigManageList.vue?vue&type=script&lang=js"
export * from "./deliveryFeeConfigManageList.vue?vue&type=script&lang=js"
import style0 from "./deliveryFeeConfigManageList.vue?vue&type=style&index=0&id=02266afd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02266afd",
  null
  
)

export default component.exports